import { useContext } from 'react';
import { DeviceTargetContext } from '../context/device-target-context';
export var useDeviceTarget = function () {
  var context = useContext(DeviceTargetContext);
  return context;
};